import { Toast } from '@hopskipdrive/react-components';
import { AUTO_HIDE_DURATION_BY_SEVERITY, useToastStoreState } from '@rideiq/shared/stores/toastStore';

import { ToastsContainer } from './styles';

export const ToastRenderer: React.FC = () => {
  const toasts = useToastStoreState((state) => state.toasts);
  const removeToast = useToastStoreState((state) => state.removeToast);

  return (
    <ToastsContainer>
      {toasts.map(({ toastId, sticky, ...toast }) => (
        <Toast
          key={toastId}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          autoHideDuration={sticky ? null : toast.autoHideDuration ?? AUTO_HIDE_DURATION_BY_SEVERITY[toast.severity]}
          onClose={(_, reason) => {
            if (reason === 'clickaway') {
              return;
            }
            removeToast(toastId);
          }}
          role="alert"
          {...toast}
        />
      ))}
    </ToastsContainer>
  );
};
